(function switchFormContent() {
    if ($('[data-form-switch-trigger]').length > 0) {
        $('[data-form-switch-trigger]').change(function () {
            var targetContainer = '#form-switch-value-' + $(this).val();

            var otherContainers = $('[id*="form-switch-value-"]');
            $(otherContainers).addClass('hidden');
            $(otherContainers).find('input').val(null);

            $(targetContainer).removeClass('hidden');
        });
    }
})();